import axios from 'axios'
import type { PerformanceBasedJobSubmitRequestData } from '../../../schema/job'
import { getApiUrl, PERFORMANCE_BASED_JOB_API_URL } from '../../util/api/api'

const submitJob = (data: PerformanceBasedJobSubmitRequestData) =>
  axios.post<void>(
    getApiUrl(`${PERFORMANCE_BASED_JOB_API_URL}/promotion/${data.jobId}`),
    data,
    {
      withCredentials: true,
    },
  )

export default submitJob
